import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';

import 'bootstrap';
import './assets/scss/main.scss';

createApp(App).mount('#app');
